import { Box, Flex, Text } from "@chakra-ui/react";
import Keyboard from "@/components/keyboard";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LogsButton } from "@/components/Button";
import TitleHeader from "@/components/TitleHeader";
import { GoIcon } from "@/components/icons";
import { createOrderForMerchant } from "@/api/order";
import { parseAmount } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";

const DirectPay = () => {
  const [value, setValue] = useState("0");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { recipient } = useParams();

  const handleCreateOrder = async () => {
    try {
      setLoading(true);
      const response = await createOrderForMerchant({
        recipient: recipient as `0x${string}`,
        orderAmount: parseAmount(value, usdcInfo.decimals),
      });
      navigate(`/pay/${response.id}`);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      flexDir={"column"}
      align={"center"}
      sx={{
        height: "100%",
        padding: "20px 20px 240px",
        position: "relative",
      }}
    >
      <TitleHeader color="#FFF" onBack={() => navigate("/")} title="Pay" />

      <Box
        sx={{
          position: "relative",
          padding: "0 20px",
          marginTop: "10vh",
        }}
      >
        <Text
          sx={{
            fontSize: "70px",
            fontStyle: "normal",
            fontWeight: 900,
            minHeight: "70px",
            textAlign: "center",
            position: "relative",
            wordBreak: "break-all",
            fontFamily: "DIN-Black",
            color: "#fff",
          }}
        >
          {value}
        </Text>
      </Box>
      <Text
        sx={{
          fontSize: "24px",
          fontStyle: "normal",
          color: "#fff",
          fontWeight: 700,
        }}
      >
        USD
      </Text>

      <LogsButton
        variant="outlined"
        sx={{
          width: "160px",
          height: "70px",
          borderRadius: "100px",
          marginTop: "16px",
          border: "1px solid #fff",
          backgroundColor: "transparent",
          color: "#fff",
        }}
        loading={loading}
        onClick={() => {
          handleCreateOrder();
        }}
      >
        <Text
          sx={{
            marginLeft: "auto",
            marginRight: "20px",
          }}
        >
          Next
        </Text>
        <GoIcon
          style={{
            width: "14px",
            height: "11px",
            marginRight: "30px",
          }}
        ></GoIcon>
      </LogsButton>

      <Keyboard
        value={value}
        onKeyboardClick={(value: string) => {
          setValue(value);
        }}
      ></Keyboard>
    </Flex>
  );
};

export default DirectPay;
